import React from 'react'
import { Instagram, Tiktok, Youtube, Linkedin, Pinterest, Headphones, Stars } from 'react-bootstrap-icons'

const platformIcons = {
  instagram: Instagram,
  tiktok: Tiktok,
  youtube: Youtube,
  pinterest: Pinterest,
  linkedin: Linkedin,
  podcast: Headphones,
  other: Stars,
}

export default function PlatformButton({ platform, isSelected, onClick }) {
  const Icon = platformIcons[platform]
  if (!Icon) return null

  return (
    <button
      className={`${isSelected ? 'text-rb-green' : 'text-rb-mat-grey'} w-7 h-7 flex items-center justify-center ${platform !== 'instagram' ? 'ml-2' : ''} rounded-md`}
      onClick={onClick}
    >
      <Icon />
    </button>
  )
}
